// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container_3CN06","total":"Search_total_2v-Ky","noResult":"Search_noResult_3f0_V","more":"Search_more_3Ga6w"};